<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-body class="py-0">
        <b-tabs small class="gridtabs" v-model="tabindex">
          <b-tab>
            <template #title>
              <div class="badgecontainer pr-2 mr-1">
                <i class="fa fa-envelope text-primary mr-1"></i>
                Email
                <b-badge id="selection" variant="primary" class="edit_tab">
                  {{ selection.length }}</b-badge>
                <b-tooltip target="selection" placement="bottom">{{ selection.length }} ticket(s)
                  selected</b-tooltip>
              </div>

            </template>

            <p class="mt-2">
            </p>
          </b-tab></b-tabs>
        <div>
          <b-row>
            <b-col cols="auto" v-if="selection.length > 1">
              <b-form-group label="eTicket style" label-for="email" label-cols="12">
                <b-form-radio-group v-model="isgroupetr" :options="[
                  { text: 'Individual', value: false },
                  { text: 'Group', value: true },
                ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"
                  class="mr-1"></b-form-radio-group>
              </b-form-group>
            </b-col>
         
            <b-col cols="auto" class="mt-3">
              <b-button-group>
                <b-form-radio-group v-model="documentformat" :options="[
                  { text: 'v1', value: 'ETR_1' },
                  { text: 'v2 (Latest)', value: 'ETR_2' }
                ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"></b-form-radio-group>
              </b-button-group>
            </b-col>
            <b-col cols="12" sm="4">
              <b-form-group label="Email To" label-for="email" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="email" placeholder="Email" size="sm"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="email = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-button squared size="sm" @click="send()" variant="primary">
                    <i class="fa fa-paper-plane pr-3"></i>Send
                  </b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "ETREmail",
  mounted() {
    this.email = this.user.email;
  },
  data() {
    return {
      busy: false,
      message: "",
      email: null,
      isgroupetr: false,
         documentformat: "ETR_1",
    };
  },
  watch: {
    selection: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:selection", newVal);
          this.isgroupetr = newVal.length > 1 ? true : false;
        }
      },
    },
  },
  methods: {
    async send() {
      this.busy = true;

      this.items = [];

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        emailto: this.email,
        documentformat: this.documentformat,
        orderby: [["slac", ""], ["[description]", "asc"], ["[travel_at]", "asc"]],
        mssql: true,
      };
      console.log("variables", variables);

      let sent = false;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $documentformat: String
              $orderby: [[String]]
              $emailto: String
              $mssql: Boolean
            ) {
              tickets(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                documentformat: $documentformat
                orderby: $orderby
                emailto: $emailto
                mssql: $mssql
              ) {
                id
              }
            }
          `,
          variables,
        });

        sent = response.data.tickets.length > 0 ? true : false;
      } catch (error) {
        console.log(error);
      }

      if (sent) {
        this.message =
          "<span class='text-primary'>Tickets will be emailed to you by SL A/C</span>";
      } else {
        this.message = "<span class='text-danger'>Email not sent!</span>";
      }
      this.busy = false;
    },
  },
};
</script>

<style></style>